import { styled } from "@mui/material/styles";

// Components
import { StyledInfoLabel } from "~/components/Layout/LayoutInfo/LayoutInfo.styled";

const styledName = "LayoutAdd";

export const StyledAddLabel = styled(StyledInfoLabel, { name: styledName })({
  "&": {
    textAlign: "center",
    marginBottom: "-50px",
    zIndex: "1",
    fontWeight: 500,
  },
});
